// src/components/ProblemSolution.js
import React from 'react';
// ✅ Using a clean, modern icon set from React Icons (Ionicons)
import { IoFlashOutline, IoPencilOutline, IoTrendingUpOutline, IoSparklesOutline } from 'react-icons/io5';

const ProblemSolution = () => {
  const points = [
    {
      icon: IoFlashOutline,
      title: "The Endless Scroll of Tasks",
      description: "Switching between 5 different tools? Manually copy-pasting content? Drowning in analytics spreadsheets? We've been there."
    },
    {
      icon: IoPencilOutline,
      title: "The Creative Block",
      description: "Staring at a blank screen, trying to come up with 30 days of unique, on-brand posts? The pressure is real."
    },
    {
      icon: IoTrendingUpOutline,
      title: "The Data Overload",
      description: "Likes and follows are nice, but what actually drives growth? Most analytics tools give you numbers, not answers."
    },
    {
      icon: IoSparklesOutline,
      title: "The Oolook Way",
      description: "One unified platform where AI helps you generate, schedule, and analyze your content in a fraction of the time. This is effortless intelligence."
    }
  ];

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 bg-gradient-to-r from-dark-accent-start to-dark-accent-end bg-clip-text text-transparent">
            Stop Juggling. Start Creating.
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            Everything you need to manage social media, in one place.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-none sm:mt-20 lg:mt-24">
          {/* ✅ Changed to a more flexible div grid from dl */}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {points.map((point) => (
              // ✅ This is the new "Glass Card"
              <div 
                key={point.title} 
                className="flex flex-col items-center p-8 text-center bg-dark-card/40 backdrop-blur-lg rounded-2xl border border-white/10 
                           transform-gpu transition-all duration-300 ease-in-out hover:scale-105 hover:border-dark-accent-start/50 hover:shadow-2xl hover:shadow-dark-accent-start/10"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end mb-6">
                  <point.icon className="h-8 w-8 text-white" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-semibold text-dark-text-primary">{point.title}</h3>
                <p className="mt-2 text-sm text-dark-text-secondary">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;